import template   from './change-password.html'
import controller from './change-password.controller'

let component = {
  restrict: 'E',
  template,
  controller
}

export default component



// WEBPACK FOOTER //
// ./src/app/pages/change-password/change-password.component.js